import { Box } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getSavedUrl2 } from 'redux/reducers/auth/selectors';
import { EMManagementIdHeader } from '../EMManagementIdHeader';
import { EmailHistory } from './EmailHistory';
import { SmsHistory } from './SmsHistory';
import { COMMUNICATION_HISTORY_TABS, TCommunicationHistoryTab } from './constants';

export const CommunicationHistory = () => {
	const savedUrl2 = useSelector(getSavedUrl2);
	const [activeTab, setActiveTab] = useState<TCommunicationHistoryTab>(
		COMMUNICATION_HISTORY_TABS.EMAIL,
	);

	const handleChange = (_event: React.SyntheticEvent, newValue: TCommunicationHistoryTab) => {
		setActiveTab(newValue);
	};

	return (
		<Box sx={{ margin: '0px 10px 0 10px' }}>
			<Box sx={{ mb: 2 }}>
				<EMManagementIdHeader savedUrl={savedUrl2} />
			</Box>
			{activeTab === COMMUNICATION_HISTORY_TABS.EMAIL && (
				<EmailHistory activeTab={activeTab} onTabChange={handleChange} />
			)}
			{activeTab === COMMUNICATION_HISTORY_TABS.SMS && (
				<SmsHistory activeTab={activeTab} onTabChange={handleChange} />
			)}
		</Box>
	);
};
